import { useDispatch, useSelector } from 'react-redux';
import { selectGLLimit, selectGLAggregateLimit } from '../../../../selectors/application';
import { setHiredAndNonOwnedAuto, setCheckedEndorsement } from '../../../../actions/application';
import { formatCurrency } from '../../../../helpers/formatNumber';
import { EndorsementKey } from '../../types';
import EndorsementSummaryCardLayout from '../../../Summary/Endorsements/EndorsementSummaryCardLayout';

const HiredAutoSummaryCard = ({ value }: { value: any }) => {
  const dispatch = useDispatch();
  const glLimit = useSelector(selectGLLimit) || 0;
  const glAggregateLimit = useSelector(selectGLAggregateLimit) || 0;

  const coverageInfo = [
    { coverage: 'Per Claim Limit', limit: formatCurrency(glLimit) },
    { coverage: 'Yearly Limit', limit: formatCurrency(glAggregateLimit) },
  ];

  const handleRemove = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.HiredAutoAndNonOwnedAuto, false));
    dispatch(setHiredAndNonOwnedAuto(null));
  };

  const handleRestore = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.HiredAutoAndNonOwnedAuto, true));
    dispatch(setHiredAndNonOwnedAuto(value));
  };

  return (
    <EndorsementSummaryCardLayout
      label="Hired and Non-Owned Auto Coverage"
      coverageInfo={coverageInfo}
      onRemove={handleRemove}
      onRestore={handleRestore}
    />
  );
};

export default HiredAutoSummaryCard;
